var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column justify-content-center align-items-center w-full text-center",staticStyle:{"height":"100vh"}},[_c('b',[_vm._v("Erreur")]),_c('h1',{staticClass:"font-weight-bolder"},[_vm._v("404")]),_c('span',[_vm._v("Cette page n'existe pas...")])])
}]

export { render, staticRenderFns }